const smsCampaigns = {
    namespaced: true,
    state: {
        campaignName: '',
        audience: null,
        message: [],
        date: '',
        hour: '',
        balance: undefined,
        invalidFields: {
            details: false,
            period: false,
            message: false,
        },
        updatedAt: {
            date: '',
            hour: '',
        },
    },
    getters: {
        getMessage: state => state.message,
        isMessageEmpty: state => state.invalidFields.message,
        hasAnyInvalidFields: state => Object.values(state.invalidFields).some(value => value),
        isButtonDisabled: (state, getters) => {
            const { campaignName, audience, message, balance, date, hour } = state;
            const isMissingRequiredField = !campaignName || !audience || !message.length || !date || !hour;
            const hasInsufficientBalance = audience?.count > balance;
            return isMissingRequiredField || getters.hasAnyInvalidFields || hasInsufficientBalance;
        },
    },
    actions: {
        setMessage({ commit }, message) {
            commit('SET_MESSAGE', message);
        },
    },
    mutations: {
        SET_MESSAGE(state, message) {
            state.message = message;
        },
        DELETE_MESSAGE(state) {
            state.message = [];
        },
        SET_DATE(state, date) {
            state.date = date;
        },
        SET_HOUR(state, hour) {
            state.hour = hour;
        },
        SET_CAMPAIGN_NAME(state, name) {
            state.campaignName = name;
        },
        SET_AUDIENCE(state, audience) {
            state.audience = audience;
        },
        SET_HAS_INVALID_FIELDS(state, { key, value }) {
            state.invalidFields[key] = value;
        },
        UPDATE_BALANCE(state, balance) {
            state.balance = balance;
        },
        UPDATE_DATE_UPDATEDAT(state, value) {
            state.updatedAt.date = value[0];
            state.updatedAt.hour = value[1];
        },
        RESET(state) {
            state.campaignName = '';
            state.audience = null;
            state.message = [];
            state.date = '';
            state.hour = '';
            state.invalidFields = {
                details: false,
                period: false,
                message: false,
            };
            state.balance = undefined;
            state.updatedAt.date = '';
            state.updatedAt.hour = '';
        },
    },
};
export default smsCampaigns;
